import ChildServiceGetters from '@/services/child/childService.getters';

export default {
  getSurvey({ commit }: any) {
    return ChildServiceGetters.getTestData();
  },
  getLanguages({ commit }: any) {
    return ChildServiceGetters.getLanguages().then(success => {
      commit("updateLanguages", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  }, 
  getChildEnrollmentStep({commit}: any, childId: string) {
    return ChildServiceGetters.getChildEnrollmentStep(childId).then(success => {
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  getCurrentViewedStep({commit}: any, childId: string) {
    return ChildServiceGetters.getCurrentViewedStep(childId).then(success => {
      commit("SET_CURRENT_VIEWED_STEP", { childId, step: success.data })

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    }) 
  },
  getChildren: ({ commit }: any) => {
    return ChildServiceGetters.getChildren().then(success => {
      commit('setChildren', success.data);

      return Promise.resolve(success.data);
    }).catch(error => {
      return Promise.reject(error);
    })
  },
  getInitialData({ commit }: any) {
    return ChildServiceGetters.getInitialData().then(success => {
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  getChildInfo({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildInfo(childId).then(success => {
      commit('updateChildInfo', success.data);
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  getChildInfoForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildInfo(childId).then(success => {
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  getSchoolArrangement({ commit }: any, childId: string) {
    return ChildServiceGetters.getSchoolArrangement(childId).then(
      (success: any) => {
        commit('updateSchoolArrangement', success.data);

        return Promise.resolve(success.data);
      },
      (error: any) => {
        return Promise.reject(error);
      }
    );
  },
  getSchoolArrangementForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getSchoolArrangement(childId).then(
      (success: any) => {
        return Promise.resolve(success.data);
      },
      (error: any) => {
        return Promise.reject(error);
      }
    );
  },
  getCustodyArrangement({ commit }: any, childId: string) {
    return ChildServiceGetters.getCustodyArrangement(childId).then(
      success => {
        commit('updateCustodyArrangement', success.data);

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },
  getCustodyArrangementForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getCustodyArrangement(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getChildPhysicalRequirements({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildPhysicalRequirements(childId).then(
      success => {
        commit('updatePhysicalRequirements', success.data);

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getChildPhysicalRequirementsForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildPhysicalRequirements(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getEmergencyContacts({ commit }: any, childId: string) {
    return ChildServiceGetters.getEmergencyContacts(childId).then(
      success => {
        commit('updateEmergencyContacts', {
          childId,
          emergencyContacts: success.data
        });
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getEmergencyContactsForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getEmergencyContacts(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getPickupPersons({ commit }: any, childId: string) {
    return ChildServiceGetters.getPickupPersons(childId).then(
      success => {
        commit('updatePickupPersons', {
          childId,
          pickupPersons: success.data
        });
        
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getPickupPersonsForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getPickupPersons(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getChildSleepArrangement({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildSleepArrangement(childId).then(
      success => {
        commit('updateChildSleepArrangement', success.data);
        
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getChildSleepArrangementForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildSleepArrangement(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getAdditionalInfo({ commit }: any, childId: string) {
    return ChildServiceGetters.getAdditionalInfo(childId).then(
      success => {
        commit('updateAdditionalInfo', {
          childId,
          additionalInfo: success.data
        });
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getAdditionalInfoForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getAdditionalInfo(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getChildrenVaccinationDates({ commit }: any, childId: string ) {
    return ChildServiceGetters.getChildrenVaccinationDates(childId).then(
      success => {
        commit('updateChildrenVaccinationDates', {
          childId: childId,
          childrenVaccinationDates: success.data
        });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getChildVaccinationDatesForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildrenVaccinationDates(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getVaccines({ commit }: any) {
    return ChildServiceGetters.getVaccines().then(
      success => {
        commit('updateVaccines', success.data);
        
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getAllergens({ commit }: any) {
    return ChildServiceGetters.getAllergens().then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getChosenAllergens({ commit }: any, childId: string) {
    return ChildServiceGetters.getChosenAllergens(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getAllergyInfo({ commit }: any, childId: string) {
    return ChildServiceGetters.getAllergyInfo(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getSkinProducts({ commit }: any) {
    return ChildServiceGetters.getSkinProducts().then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getChildSkinProducts({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildSkinProducts(childId).then(
      success => {
        commit("updateChildSkinProducts", {
          childId,
          skinProducts: success.data
        });
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getChildSkinProductsForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildSkinProducts(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getInvitationLink(context: any, data: any) {
    return ChildServiceGetters.getInvitationLink().then(success => {
      context.commit('setInvitationLink', success.data);
      
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  getProviderInvitationLink(context: any, data: any) {
    return ChildServiceGetters.getProviderInvitationLink(data).then(success => {
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  getHealthInformation({ commit }: any, context: any) {
    return ChildServiceGetters.getHealthInformation().then(success => {
      commit('setInitialHealthInfo', success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  getChildFeedingArrangement({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildFeedingArrangement(childId).then(
      success => {
        commit("updateChildFeedingArrangement", {
          childId,
          feedingArrangement: success.data
        });
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },
  getChildFeedingArrangementForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getChildFeedingArrangement(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getAdditionalEmergencyInfo({ commit }: any, childId: string) {
    return ChildServiceGetters.getAdditionalEmergencyInfo(childId).then(
      success => {
        commit('updateChildSleepArrangement', {
          childId,
          additionalEmergencyInfo: success.data
        });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  getAdditionalEmergencyInfoForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.getAdditionalEmergencyInfo(childId).then(
      success => {
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },
  populateHealthInformation({ commit }: any, childId: string) {
    return ChildServiceGetters.populateHealthInformation(childId).then(success => {
      commit('updateHealthInfo', { childId, healthInfo: success.data });

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  }, 
  populateHealthInformationForProvider({ commit }: any, childId: string) {
    return ChildServiceGetters.populateHealthInformation(childId).then(success => {
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  }
}